import { render, staticRenderFns } from "./jxInfo.vue?vue&type=template&id=d66dd6f4&scoped=true"
import script from "./jxInfo.vue?vue&type=script&lang=js"
export * from "./jxInfo.vue?vue&type=script&lang=js"
import style0 from "./jxInfo.vue?vue&type=style&index=0&id=d66dd6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66dd6f4",
  null
  
)

export default component.exports